<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Notes" class="d-icon d-icon--notes" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12"><path fill="currentColor" fill-rule="evenodd" d="M4 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h.5A1.5 1.5 0 0 1 11 3v7a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 2 10V3a1.5 1.5 0 0 1 1.5-1.5H4Zm0 1h-.5A.5.5 0 0 0 3 3v7a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm4 0H5v-1h3v1Zm-4 3a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM4 8a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8Zm2 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 6 8Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconNotes',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
